export default {
  ADD_ACCOUNTS (state, accounts) {
    state.accounts = accounts
  },
  ADD_ROLES (state, roles) {
    state.roles = roles
  },
  ADD_NEW_ACCOUNT (state, account) {
    const acc = state.accounts.find(a => a.tempId === account.tempId)
    acc.isNew = false
    acc.email = account.email
    acc.role = account.role
    acc.id = account.id
    acc.password = ''
  },
  ADD_ACCOUNT_SCHEMA (state, accountSchema) {
    state.accounts.unshift(accountSchema)
  },
  DELETE_ACCOUNT  (state, id) {
    state.accounts = state.accounts.filter(d => d.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/accounts.js